import { Button, Filter, Icon, Search, Tag, Dropdown, Switcher, TextInput, DateRangePicker, DatePickerInput, DatePickerMenu } from 'pepsico-ds';
import React, { useState, useRef, useEffect, useContext } from 'react';
import './workflow.css';
import PendingApprovals from './pending_approval';
import { useLocation, useNavigate } from 'react-router-dom';
// import { useLoading } from '../../loader';
import SkeletonBox from '../../common/skeletonBox';
import { useTranslation } from 'react-i18next';
import { DateRange } from 'react-date-range';
import { addDays, format } from "date-fns";
import { enUS } from "date-fns/locale";
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import {
    Box,
    ClickAwayListener,
    Popper,
    TextField,
    Paper
} from "@mui/material";
import ErrorFailOverHandler from '../../common/error_fail_over_handler';
import { Tooltip } from 'react-tooltip';
import betaVersionIcon from "../../assets/beta_superscript.gif";
import { UserProfileContext } from '../../common/user_profile_context';
import Outage from '../../common/outage';

function useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = React.useState(value);

    React.useEffect(() => {
        const handler = setTimeout(() => setDebouncedValue(value), delay);
        return () => clearTimeout(handler);
    }, [value, delay]);

    return debouncedValue;
}

const Approvals = () => {
    const location = useLocation();
    const roles = location?.state?.roles || [];
    const { userProfile } = useContext(UserProfileContext);
    // console.log("roles in approvals:", roles);
    const [selectedTabIndex, setSelectedTabIndex] = useState(0);
    const [selectedApprovalTabIndex, setSelectedApprovalTabIndex] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const agGridRef = useRef();
    const navigate = useNavigate();
    const [selectedCount, setSelectedCount] = useState(0);
    const [checkedIndexes, setCheckedIndexes] = useState([]);
    const [changedValue, setChangedValue] = useState('');
    const [gridToCard, setGridToCard] = useState(false);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [showErrorPage, setShowErrorPage] = useState(false);
    const [isGridType, setIsGridType] = React.useState(true);
    const [searchTerm, setSearchTerm] = useState(null);
    const debouncedSearchTerm = useDebounce(searchTerm, 500);
    const [searchText, setSearchText] = useState('');
    const [displayMode, setDisplayMode] = useState('GRID');
    const [filterString, setFilterString] = useState('');
    const { t, i18n } = useTranslation();
    const filterOptions = ['Approvals', 'Delegated Approvals'];
    // const filterOptions = [
    //     { id: 0, label: 'Approvals' },
    //     { id: 1, label: 'Delegated Approvals' }
    // ]
    const [shouldFetch, setShouldFetch] = useState(false);
    const [reFetchAfterClear, setReFetchAfterClear] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);
    const [refresh, setRefresh] = useState(false);
    const [selectedDate, setSelectedDate] = useState({
        from: null,
        to: null
    });
    const [clearDateClicked, setClearDateClicked] = useState(false);
    const [selectedTypeTabIndex, setSelectedTypeTabIndex] = useState(location.state?.isEntraApproval ? 1 : location.state?.isMyPamApproval ? 2 : location.state?.isSSOApproval ? 3 : location.state?.isRetirementApproval ? 4 : 0);
    const [fetchAfterTabChange, setFetchAfterTabChange] = useState(false);
    const selectedTabOutageSystem = selectedTypeTabIndex === 0
        ? (userProfile?.systemsStatus?.myidM ? 'myidM' : null)
        : selectedTypeTabIndex === 1
            ? (userProfile?.systemsStatus?.DS ? 'DS' : null)
            : selectedTypeTabIndex === 2
                ? (userProfile?.systemsStatus?.myPAM ? 'myPAM' : null)
                : selectedTypeTabIndex === 3
                    ? (userProfile?.systemsStatus?.SSO ? 'SSO' : null)
                    : null;
    // const handleRangeChange = (item) => {
    //     const { startDate, endDate } = item.selection;

    //     setFromDate(startDate);
    //     setToDate(endDate || null);

    //     // Close only if both dates are selected and valid
    //     if (startDate && endDate && startDate.getTime() < endDate.getTime()) {
    //         // setFromDate(startDate);
    //         // setToDate(endDate);
    //         setChangedValue("dateRange");
    //         setOpen(false);
    //         setShouldFetch(true);
    //     }
    //     // setChangedValue('dateRange');
    // };

    const handleRefresh = () => {
        setChangedValue('refresh');
        setRefresh(true);
        setTimeout(() => {
            setChangedValue('');
            setRefresh(false);
        }, 100);
    }

    const formatDate = (date) => {
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    // const formatRangeLabel = () => {
    //     // const { startDate, endDate } = range[0];
    //     if (!fromDate || !toDate) {
    //         return '';
    //     }
    //     return formatDate(fromDate) + " - " + formatDate(toDate) || '';
    // };

    const handleResetFetch = () => {
        setShouldFetch(false);
    };

    const handleShowErrorPage = (value) => {
        if (value) {
            setShowErrorPage(true);
        }
    };
    const [isTab, setIsTab] = useState(
        window.innerWidth > 768 && window.innerWidth <= 1024
    );

    useEffect(() => {

        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
            setIsTab(window.innerWidth > 768 && window.innerWidth <= 1024);
        };

        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const handleSearch = React.useCallback((value) => {
        setSearchTerm(value?.trim?.() ?? "");
        setChangedValue('searchTerm');
    }, []);
    // const handleSearch = (event) => {
    //     setSearchTerm(event || '');
    //     setChangedValue('searchTerm');
    //     // setTimeout(() => {
    //     //     setChangedValue('');
    //     // }, 1000);
    // };

    const handleResetSearch = () => {
        setChangedValue('');
    };

    const handleDataFromPendingApproval = (data) => {
        if (data.selectedCount) {
            setSelectedCount(data.selectedCount);
        }
    };

    const setDisplayType = (type) => {
        setIsGridType(type === 'GRID' ? true : false);
        setDisplayMode(type);
        if (type === 'GRID' && agGridRef.current) {
            setCheckedIndexes(agGridRef.current.getSelectedRowData());
            setGridToCard(true);
        }
        else {
            setGridToCard(false);
        }
    }

    const filterRecords = (actionType) => {
        setFilterString(actionType);
        setChangedValue('filterString');
        setTimeout(() => {
            setChangedValue('');
        }, 100);
    }

    // const handleDateChange = ({ event, type }) => {
    //     const selectedDate = event;
    //     if (!selectedDate) {
    //         return;
    //     }
    //     if (type === 'from') {
    //         setFromDate(selectedDate);
    //         if (!toDate || new Date(selectedDate) > new Date(toDate)) {
    //             setToDate(null);
    //         }
    //     } else {
    //         setToDate(selectedDate);
    //     }
    //     setChangedValue('dateRange');
    // }

    const resetFilters = () => {
        setFromDate(null);
        setToDate(null);
        setSelectedDate({
            from: null,
            to: null
        });
        setSearchTerm('');
        setShouldFetch(false);
        setFilterString('');
        setChangedValue('searchTerm');
        setReFetchAfterClear(true);
        setTimeout(() => {
            setChangedValue('');
        }, 100);
    };

    const selectedTab = (index) => {
        if (index?.[0]?.id === 0 || index?.[0]?.id) {
            setSelectedTabIndex(index?.[0]?.id);

        } else {
            setSelectedTabIndex(index);
        }
    };

    const filterItems = [t('approvals.pending'), t('approvals.expiring'), t('approvals.overdue')];

    return (
        <>
            {showErrorPage ? (
                <ErrorFailOverHandler
                    header="No Data found"
                    title="Uh oh, we can’t seem to find the page you’re looking for."
                    supportMessage="Try going back or contact"
                    supportLabel="Support"
                    supportLink="mailto:DL-IAMCentralOperations@pepsico.com?subject=Support Request&body=Hello Team,"
                    alternateMessage="You can also complete tasks in myidM"
                    alternateLabel="Go to myIDM"
                    alternateLink="https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=PendingApprovals"
                    image="src/assets/error.png" />
            ) : (
                <div id="pendingApprovals">
                    {isMobile && <div style={{ display: "flex" }} className='mb-3 mt-3'>
                        <div>
                            <Button
                                size="small"
                                text="MyidM"
                                iconLeading="arrow_back"
                                variant=""
                                className="link"
                                onClick={() => navigate('/home')}
                                style={{ backgroundColor: "none !important" }}
                            />
                        </div>
                    </div>}
                    <div className={isMobile ? 'd-grid align-items-center mb-3' : 'd-flex justify-content-between align-items-center mb-3'}>
                        <span className="page-header">{t('approvals.pending_approval')}
                            {isMobile &&
                                <sup className='beta_version'> <img
                                    src={betaVersionIcon}
                                    style={{
                                        width: "32px",
                                        height: "30px",
                                    }}
                                    alt="Pepsico"
                                /></sup>
                            }
                        </span>
                        {/* {isLoading ? (
                <>
                    <SkeletonBox width="200px" height="36px" />
                </>
            ) : (
                <>
                    <Switcher className={isMobile ? 'mt-4 ml-auto' : ''}
                        items={filterItems}
                        selectedItemIndex={0}
                        onUpdate={(selectedIndex) => filterRecords(filterItems[selectedIndex])}
                    />
                </>
            )} */}
                    </div>
                    <div className='card p-4'>
                        {/* <Switcher
                            className="mb-3" style={{ width: 'fit-content' }}
                            items={filterOptions}
                            onUpdate={(index) => {
                                setSelectedApprovalTabIndex(index)
                            }}
                            selectedItemIndex={selectedApprovalTabIndex}
                        /> */}
                        <div className={isMobile ? 'd-grid filtersMobile' : 'd-flex filters'} >
                            <div className='d-flex'>
                                <div className='d-flex' style={{ backgroundColor: '#dfeaf9', padding: '4px', borderRadius: '8px', width: isMobile ? 'max-content' : 'auto' }}>
                                    {isLoading ? (
                                        <>
                                            <div className='mb-3 d-flex' style={{ gap: '1rem' }}>
                                                <SkeletonBox width="40px" height="16px" />
                                                <SkeletonBox width="40px" height="16px" />
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            {/* <Switcher className={isMobile ? 'mt-4 ml-auto' : ''}
                                items={filterOptions}
                                selectedItemIndex={0}
                                onUpdate={(selectedIndex) => setDisplayType(selectedIndex?.[0]?.id === 0 ? 'GRID' : 'LIST')}
                            /> */}
                                            <Icon icon="grid_on" className={`${isGridType === true ? 'filterIcon' : 'filterIcon'}`} onClick={() => setDisplayType('GRID')} />
                                            <Icon icon="list_alt" className={`${isGridType === false ? ' filterIcon' : 'filterIcon'}`} onClick={() => setDisplayType('LIST')} />
                                        </>
                                    )}
                                </div>
                                <Icon
                                    alt="alt value"
                                    className="$color-icon-default"
                                    icon="refresh"
                                    data-tooltip-id="refresh-tooltip" data-tooltip-content="Refresh"
                                    size="medium"
                                    onClick={() => handleRefresh()}
                                    style={{ alignItems: 'center', marginLeft: '0.5rem', marginRight: '0.5rem', cursor: 'pointer' }}
                                />
                                <Tooltip id="refresh-tooltip" place="top" style={{ maxWidth: '200px' }} type="light" effect="solid" />
                                <Switcher
                                    className=""
                                    items={[
                                        {
                                            label: t("nonArExtension.myidm"),
                                        },
                                        // {
                                        //     label: t("homePage.pepagm"),
                                        // },
                                        {
                                            label: t("entraGuest.entra"),
                                        },
                                        {
                                            label: t("homePage.mypam"),
                                        },
                                        {
                                            label: "SSO",
                                        },
                                        {
                                            label: t("app_retirement.app_retirements"),
                                        }
                                    ]}
                                    selectedItemIndex={selectedTypeTabIndex}
                                    onUpdate={(n)=>{
                                        setSelectedTypeTabIndex(n);
                                        // if(n==1){
                                        //     window.open(
                                        //         "https://pepagm.mypepsico.com/sigma/app/index#/campaigns",
                                        //         "_blank"
                                        //     )
                                        // }else{
                                            setFetchAfterTabChange(true);

                                            setClearDateClicked(true);
                                            setTimeout(()=>{
                                                setClearDateClicked(false);
                                            },100);
                                            setFromDate(null);
                                            setToDate(null);
                                            setSelectedDate({
                                                from: null,
                                                to: null
                                            });
                                            setSearchTerm('');
                                            setFilterString('');
                                            setChangedValue('searchTerm');
                                            setTimeout(() => {
                                                setChangedValue('');
                                            }, 100);
                                        // }
                                    }}
                                    size="medium"
                                    style={{}}
                                    variant="default"
                                />
                            </div>
                            <div className={isMobile ? 'd-grid' : 'd-flex'} style={{ gap: !isMobile ? '1rem' : '', alignItems: 'baseline' }}>
                                {isLoading ? (
                                    <>
                                        <div className='mb-3 d-flex' style={{ gap: '1rem' }}>
                                            <SkeletonBox width="200px" height="36px" />
                                            <SkeletonBox width="200px" height="36px" />
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <Search
                                            className='approvals-search'
                                            isAutoComplete={false}
                                            autoComplete="off"
                                            isClearable={searchTerm?.length>0}
                                            menuPosition="bottom-right"
                                            placeholderText="Type a request number"
                                            onSearch={() => handleSearch(searchTerm)}
                                            onUpdate={(value) => handleSearch(value)}
                                            onClear={() => { handleSearch('') }}
                                            value={searchTerm}
                                            delay={0}
                                        />
                                        <DateRangePicker
                                            className="bulk-date-filter-input"
                                            endYear={2030}
                                            feedbackType={t('nonArExtension.info')}
                                            format="mm/dd/yyyy"
                                            helperText=""
                                            inputSize="medium"
                                            placeholder='MM/DD/YYYY - MM/DD/YYYY'
                                            selectedDateRange={selectedDate}
                                            onSelectDateRange={(date)=>{
                                                if(!clearDateClicked)setSelectedDate(date);
                                                if((date.from && date.to) || (!date.from && !date.to)){
                                                    setChangedValue("dateRange");
                                                    setShouldFetch(true);
                                                }
                                            }}
                                            startYear={1950}
                                            // disabled={selectedFilter ? false : true}
                                            style={{}}
                                            datePickerMenu={{
                                                disabled:{
                                                    afterDate: new Date()
                                                }
                                            }}
                                        />
                                        {/* <div style={{ position: 'relative', width: isMobile ? '100%' : 'fit-content' }}>
                                            <Box>
                                                <ClickAwayListener
                                                    onClickAway={(event) => {
                                                        if (
                                                            anchorRef.current &&
                                                            anchorRef.current.contains(event.target)
                                                        ) {
                                                            // Clicked on input, don't close
                                                            return;
                                                        }

                                                        const popperEl = document.querySelector('.MuiPopper-root');
                                                        if (popperEl && popperEl.contains(event.target)) {
                                                            // Clicked inside calendar, don't close
                                                            return;
                                                        }

                                                        setOpen(false);
                                                    }}
                                                >
                                                    <Box
                                                        onMouseDown={(e) => {
                                                            if (e.button === 2) {
                                                                // Prevent right-click from closing calendar
                                                                e.stopPropagation();
                                                            }
                                                        }}
                                                    >
                                                        <TextInput
                                                            placeholderText="DD/MM/YYYY - DD/MM/YYYY"
                                                            ref={anchorRef}
                                                            onClick={() => setOpen((prev) => !prev)}
                                                            value={formatRangeLabel()}
                                                            readOnly
                                                            showLabelIcon={false}
                                                            className="dateRangeInput"
                                                        />

                                                        <Popper open={open} anchorEl={anchorRef.current} placement="bottom-start">
                                                            <Paper elevation={3}>
                                                                <DateRange
                                                                    locale={enUS}
                                                                    editableDateInputs={false}
                                                                    onChange={handleRangeChange}
                                                                    moveRangeOnFirstSelection={false}
                                                                    ranges={[
                                                                        {
                                                                            startDate: fromDate,
                                                                            endDate: toDate,
                                                                            key: 'selection',
                                                                        },
                                                                    ]}
                                                                    months={1}
                                                                    direction="horizontal"
                                                                    maxDate={new Date()}
                                                                />
                                                            </Paper>
                                                        </Popper>
                                                    </Box>
                                                </ClickAwayListener>
                                            </Box>
                                        </div> */}

                                        {/* <div className={isMobile ? 'd-flex' : 'd-flex'} style={{ gap: '8px', alignItems: 'baseline' }}>
                                <span>From</span>
                                <DatePickerInput
                                    className={isMobile ? 'isMobile mb-3' : 'mb-3'}
                                    endYear={2030}
                                    feedbackType="info"
                                    format="mm/dd/yyyy"
                                    helperText=""
                                    inputSize="medium"
                                    placeholder="mm/dd/yyyy"
                                    selected={fromDate}
                                    setSelected={(event) => handleDateChange({ event: event, type: 'from' })}
                                    startYear={1950}
                                    style={{}}
                                />
                            </div>
                            <div className={isMobile ? 'd-flex' : 'd-flex'} style={{ gap: '8px', alignItems: 'baseline' }}>
                                <span>To</span>
                                <DatePickerInput
                                    className={isMobile ? 'isMobile mb-3' : 'mb-3'}
                                    endYear={2030}
                                    feedbackType="info"
                                    format="yyyy-mm-dd"
                                    helperText=""
                                    inputSize="medium"
                                    placeholder="mm/dd/yyyy"
                                    selected={toDate}

                                    setSelected={(event) => handleDateChange({ event: event, type: 'to' })}
                                    startYear={1950}
                                    style={{}}
                                />
                            </div> */}
                                        <Button
                                            size="small"
                                            text="Clear Date"
                                            disabled={!selectedDate?.from && !selectedDate?.to}
                                            variant="tertiary"
                                            onClick={() => {
                                                setClearDateClicked(true);
                                                resetFilters();
                                                setTimeout(()=>{
                                                    setClearDateClicked(false);
                                                },100);
                                            }}
                                        />
                                    </>
                                )}
                            </div>
                        </div>
                        {isLoading ? (
                            <>
                                <div style={{ width: '100%', height: 'calc(100vh - 300px)' }} >

                                </div>
                            </>
                        ) : (
                           selectedTabOutageSystem
                           ? <Outage outageSystem={selectedTabOutageSystem} />
                           : <PendingApprovals key={selectedTypeTabIndex} roles={roles} changedValue={changedValue} debouncedSearchTerm={debouncedSearchTerm} searchTerm={searchTerm} dateRange={selectedDate} refresh={refresh} shouldFetch={shouldFetch} onResetFetch={handleResetFetch} onResetSearch={handleResetSearch} onShowErrorPage={handleShowErrorPage} filterString={filterString} gridToCard={gridToCard} displayType={displayMode} onDataFromPendingApprovals={handleDataFromPendingApproval} selectedApprovalTabIndex={selectedApprovalTabIndex} resetFilters={resetFilters} handleSearch={handleSearch} setReFetchAfterClear={setReFetchAfterClear} reFetchAfterClear={reFetchAfterClear}  isEntraApproval={selectedTypeTabIndex === 1} isMyPamApproval={selectedTypeTabIndex === 2} isSSOApproval={selectedTypeTabIndex === 3} isRetirementApproval={selectedTypeTabIndex === 4} setFetchAfterTabChange={setFetchAfterTabChange} fetchAfterTabChange={fetchAfterTabChange} ></PendingApprovals>
                        )}

                    </div>
                </div >
            )}
        </>

    )
};
export default Approvals;